export interface AuditLogEntry {
  timestamp: number;
  username: string;
  action: string;
  ipAddress: string;
  reason?: string;
}

export enum AuditLogEvent {
  LOGGED_IN_WITH_TFA = 'LOGGED_IN_WITH_TFA',
  LOGGED_IN = 'LOGGED_IN',
  MFA_CODE_EXPIRED = 'MFA_CODE_EXPIRED',
  MFA_CODE_NOT_PROVIDED = 'MFA_CODE_NOT_PROVIDED',
  MFA_REQUIRED = 'MFA_REQUIRED',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  LOGOUT = 'LOGOUT',
  PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST',
  PASSWORD_CHANGE = 'PASSWORD_CHANGE',
  MFA_SUCCESS = 'MFA_SUCCESS',
  MFA_FAILURE = 'MFA_FAILURE',
  PASSWORD_RESET_KEY_EXPIRED = 'PASSWORD_RESET_KEY_EXPIRED',
}

export const auditLogEventLabels: Record<AuditLogEvent, string> = {
  [AuditLogEvent.LOGGED_IN_WITH_TFA]: 'Logged In With TFA',
  [AuditLogEvent.LOGGED_IN]: 'Logged In',
  [AuditLogEvent.MFA_CODE_EXPIRED]: 'MFA Code Expired',
  [AuditLogEvent.MFA_CODE_NOT_PROVIDED]: 'MFA Code Not Provided',
  [AuditLogEvent.MFA_REQUIRED]: 'MFA Required',
  [AuditLogEvent.LOGIN_SUCCESS]: 'Login Success',
  [AuditLogEvent.LOGIN_FAILURE]: 'Login Failure',
  [AuditLogEvent.LOGOUT]: 'Logout',
  [AuditLogEvent.PASSWORD_RESET_REQUEST]: 'Password Reset Request',
  [AuditLogEvent.PASSWORD_CHANGE]: 'Password Change',
  [AuditLogEvent.MFA_SUCCESS]: 'MFA Success',
  [AuditLogEvent.MFA_FAILURE]: 'MFA Failure',
  [AuditLogEvent.PASSWORD_RESET_KEY_EXPIRED]: 'Password Reset Key Expired',
};
